export default {
  data() {
    const emailRegexp = /\S+@\S+\.\S+/i;
    return {
      isFormValid: true,
      validation: {
        email: (val) =>
          !val || (val && emailRegexp.test(val)) || "Invalid email",
        required: (val) => !!val || "This field is reqired",
        password: [
          (value) =>
            (value && value.length > 5) ||
            "Password length must be greater than 5",
        ],
      },
    };
  },
  methods: {
    validate() {
      return this.$refs.form.validate();
    },
  },
};
